const STORAGE_KEY = 'tkw-mobile.theme';

export type Theme = 'light' | 'dark';

/**
 * Applies the persisted theme (or system preference if none is stored) to the body.
 */
export function initTheme(): void {
  const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const theme: Theme = stored || (systemDark ? 'dark' : 'light');
  applyTheme(theme);
}

/**
 * Returns the currently active theme by inspecting the body class.
 */
export function getTheme(): Theme {
  return document.body.classList.contains('dark') ? 'dark' : 'light';
}

/**
 * Toggles between light and dark and persists the choice.
 */
export function toggleTheme(): Theme {
  const next: Theme = getTheme() === 'dark' ? 'light' : 'dark';
  applyTheme(next);
  localStorage.setItem(STORAGE_KEY, next);
  return next;
}

function applyTheme(theme: Theme): void {
  document.body.classList.toggle('dark', theme === 'dark');
}
